import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box } from "@mui/material";
import { useChannelContext } from "@sendbird/uikit-react/Channel/context";

export function ChannelDescriptionBanner(): JSX.Element | null {
  const { currentGroupChannel } = useChannelContext();

  const description = (currentGroupChannel?.cachedMetaData as { description: string } | undefined)
    ?.description;

  if (!isDefined(description)) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.background.tertiary,
        borderBottom: `1px solid ${theme.palette.divider}`,
        paddingX: 5,
        paddingY: 3,
      })}
    >
      <Text
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.text.secondary,
          textAlign: "center",
        })}
      >
        {description}
      </Text>
    </Box>
  );
}
